import React, { useId } from 'react';
import classnames from 'classnames';
import { RadioGroupItem } from '@foodamigos/ui';

/**
 * One choice of a design-system RadioGroup as a bordered row with a name and a line of
 * detail; the whole row is the hit area. Selected: brand border and tint.
 * Content shown only for the selected choice (e.g. its fields) goes in `children`, under the row.
 */
export default function RadioCard({ value, title, description, disabled = false, selected = false, testId, children }) {
  const id = useId();

  return (
    <div className="flex flex-col gap-[var(--fa-space-2)]">
      <label
        htmlFor={id}
        data-testid={testId}
        className={classnames(
          'flex items-start gap-[var(--fa-space-3)] rounded-[var(--fa-radius-md)] border p-[var(--fa-space-3)] transition-colors',
          {
            'cursor-pointer border-[var(--fa-color-border)] bg-[var(--fa-color-surface)] hover:border-[var(--fa-color-border-strong)]':
              !selected && !disabled,
            'cursor-pointer border-[var(--fa-color-brand)] bg-[var(--fa-color-brand-subtle)]': selected,
            'cursor-not-allowed border-[var(--fa-color-border)] opacity-60': disabled,
          },
        )}
      >
        <RadioGroupItem id={id} value={value} disabled={disabled} className="mt-px shrink-0" />
        <span className="flex min-w-0 flex-col gap-[2px]">
          <span className="text-[length:var(--fa-font-size-md)] font-semibold text-[var(--fa-color-text)]">
            {title}
          </span>
          {description && (
            <span className="break-words text-[length:var(--fa-font-size-sm)] text-[var(--fa-color-text-muted)]">
              {description}
            </span>
          )}
        </span>
      </label>
      {selected && children}
    </div>
  );
}
